import { convertTimeLetter } from '@helpers';
import { UseManagePaidBarChartHeaderParams, UseManagePaidBarChartHeaderReturn } from '@components/ncFiles/components/paid/components/barChart/types';

export const useManagePaidBarChartHeader = ({
  item,
  barValueName,
  lineValueName,
  selectedBar,
  selectedBarIndex,
  barBlockWidth,
}: UseManagePaidBarChartHeaderParams): UseManagePaidBarChartHeaderReturn => {
  const dataNotAvailable = !item?.data?.loaded || item?.data?.error;

  const leftElement = dataNotAvailable
    ? { m: 0, h: 0 }
    : selectedBar
      ? convertTimeLetter(selectedBar?.[lineValueName])
      : convertTimeLetter(item?.data?.data?.statisticsOverall?.[lineValueName]);

  const rightElement = dataNotAvailable
    ? { m: 0, h: 0 }
    : selectedBar
      ? convertTimeLetter(selectedBar?.[barValueName])
      : convertTimeLetter(item?.data?.data?.statisticsOverall?.[barValueName]);

  const lineLeft = selectedBarIndex ? selectedBarIndex * barBlockWidth + barBlockWidth / 2 : 0;

  return {
    dataNotAvailable,
    leftElement,
    rightElement,
    lineLeft,
  };
};
